"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles = ({ palette, defaults, mixins }) => ({
    root: {
        position: 'relative',
    },
    gutters: {
        minHeight: defaults.headers.headerHeight,
        paddingLeft: defaults.content.paddingLeftMobile,
        paddingRight: defaults.content.paddingRightMobile,
        '@media (min-width: 769px)': {
            paddingLeft: defaults.content.paddingLeft,
            paddingRight: defaults.content.paddingRight,
        },
    },
    toolbar: Object.assign({}, mixins.toolBar),
    appBar: Object.assign(Object.assign({}, mixins.appBar), { zIndex: 1102 }),
    content: {
        display: 'flex',
        flexGrow: 1,
        '@media (min-width: 769px)': {
            paddingLeft: defaults.content.paddingLeft,
        },
    },
    onHoverActive: {
        minWidth: 129,
        '&:hover': {
            backgroundColor: palette.background.elevated,
        },
    },
    leftContent: {
        borderRight: 'none',
        position: 'inherit',
        minHeight: '100%',
        width: 'initial',
        '& svg': {
            color: palette.text.primary,
        },
        '& > nav': {
            display: 'grid',
            alignItems: 'center',
            gridTemplateColumns: 'repeat(2, 50%)',
            gridAutoRows: '90px',
            minWidth: 0,
            '& > div': {
                alignSelf: 'stretch',
                flexDirection: 'column',
                textAlign: 'center',
                borderRadius: 8,
                '& :first-of-type': {
                    justifyContent: 'center',
                    marginRight: 0,
                },
            },
        },
        '@media (min-width: 769px)': {
            '&& > nav': {
                display: 'block',
                '& > div': {
                    flexDirection: 'row',
                    textAlign: 'left',
                    borderRadius: '8px 0px 0px 8px',
                },
            },
            borderRight: `1px solid ${palette.border.default}`,
            position: 'fixed',
            width: 240,
        },
    },
    tabs: {
        paddingRight: defaults.content.paddingRightMobile,
        width: '100%',
        '@media (min-width: 769px)': {
            paddingLeft: 0,
        },
    },
    rightContent: {
        display: 'flex',
        flexDirection: 'column',
        marginLeft: 0,
        padding: 20,
        overflow: 'auto',
        '@media (min-width: 769px)': {
            marginLeft: 240,
        },
        '@media (max-width: 980px)': {
            padding: 40,
        },
    },
    selectedList: {
        borderBottom: `2px solid ${palette.primary.dark}`,
        backgroundColor: `${palette.background.elevated} !important`,
        '@media (min-width: 769px)': {
            borderBottom: 'none',
        },
    },
});
exports.default = styles;
